import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { MdOutlineWorkspacePremium } from "react-icons/md";

// Imported Images
import img1 from "../Infrastructure/imgs/img_1.jpg";
import img2 from "../Infrastructure/imgs/img_2.jpg";
import img3 from "../Infrastructure/imgs/img_3.jpg";
import img4 from "../Infrastructure/imgs/img_4.jpg";
import img5 from "../Infrastructure/imgs/img_5.jpg";
import img6 from "../Infrastructure/imgs/img_6.jpg";
import img7 from "../Infrastructure/imgs/img_7.jpg";
import img8 from "../Infrastructure/imgs/img_8.jpg";
import img9 from "../Infrastructure/imgs/img_9.jpg";
import img10 from "../Infrastructure/imgs/img_10.jpg";
import img11 from "../Infrastructure/imgs/img_11.jpg";
import img12 from "../Infrastructure/imgs/img_12.jpg";
import img13 from "../Infrastructure/imgs/img_13.jpg";
import img14 from "../Infrastructure/imgs/img_14.jpg";
import img15 from "../Infrastructure/imgs/img_15.jpg";
import img16 from "../Infrastructure/imgs/img_16.jpg";
import img17 from "../Infrastructure/imgs/img_17.jpg";
import img18 from "../Infrastructure/imgs/img_18.jpg";
import img19 from "../Infrastructure/imgs/img_19.jpg";
import img20 from "../Infrastructure/imgs/img_20.jpg";
import { Link } from "react-router-dom";
// import { MdOutlineWorkspacePremium } from "react-icons/md";

const infrastructure = [
  {
    id: 1,
    image: img1,
    title: "أعمالنا الخاصة بالبنية التحتية",
  },
  {
    id: 2,
    image: img2,
    title: "أعمالنا الخاصة بالبنية التحتية",
  },
  {
    id: 3,
    image: img3,
    title: "أعمالنا الخاصة بالبنية التحتية",
  },
  {
    id: 4,
    image: img4,
    title: "أعمالنا الخاصة بالبنية التحتية",
  },
  {
    id: 5,
    image: img5,
    title: "أعمالنا الخاصة بالبنية التحتية",
  },
  {
    id: 6,
    image: img6,
    title: "أعمالنا الخاصة بالبنية التحتية",
  },
];

const gallery = [
  {
    id: 1,
    image: img1,
  },
  {
    id: 2,
    image: img2,
  },
  {
    id: 3,
    image: img3,
  },
  {
    id: 4,
    image: img4,
  },
  {
    id: 5,
    image: img5,
  },
  {
    id: 6,
    image: img6,
  },
  {
    id: 7,
    image: img7,
  },
  {
    id: 8,
    image: img8,
  },
  {
    id: 9,
    image: img9,
  },
  {
    id: 10,
    image: img10,
  },
  {
    id: 11,
    image: img11,
  },
  {
    id: 12,
    image: img12,
  },
  {
    id: 13,
    image: img13,
  },
  {
    id: 14,
    image: img14,
  },
  {
    id: 15,
    image: img15,
  },
  {
    id: 16,
    image: img16,
  },
  {
    id: 17,
    image: img17,
  },
  {
    id: 18,
    image: img18,
  },
  {
    id: 19,
    image: img19,
  },
  {
    id: 20,
    image: img20,
  },
];

const Infrastructure = () => {
  return (
    <>
      <section>
        <div class="relative w-full h-[320px]" id="home">
          <div class="absolute inset-0 opacity-70">
            <img
              src={img3}
              alt="Background Image"
              class="object-cover bg-no-repeat object-center w-full h-full"
            />
          </div>
          <div class="absolute inset-0 flex items-center justify-center">
            <div class="text-center">
              <h1 class="text-grey-700 font-medium text-4xl md:text-5xl leading-tight mb-2">
                البنية التحتية
              </h1>
              <br />
              <br />
              <Link
                to="/contactUs"
                class="px-6 py-3 bg-rose-500 text-white font-medium rounded-full hover:bg-rose-600 transition duration-200">
                تواصل معنا
              </Link>
            </div>
          </div>
        </div>

        <section class="py-10" id="services">
          <div class="container mx-auto px-4">
            <h2 class="text-3xl font-bold text-gray-800 mb-8 text-center">
              أعمالنا السابقة
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
              {infrastructure.map((bridge, index) => (
                <div
                  key={index}
                  class="bg-white rounded-lg shadow-md overflow-hidden">
                  <img
                    lazy="loading"
                    src={bridge.image}
                    alt="wheat flour grinding"
                    class="w-full h-64 object-cover"
                  />
                  <div class="p-6 text-center">
                    <h3 class="text-xl font-medium text-gray-800 mb-2">
                      {bridge.title}
                    </h3>
                    <button id="btn" class="text-gray-700 mt-5 text-base">
                      <a
                        href="tel:+201095593610"
                        className="ml-10 bg-slate-200 hover:bg-slate-300 px-6 p-1 text-xl text-gray-950 rounded-md">
                        اتصل بنا
                      </a>
                      <a
                        href="https://wa.me/+201145337673"
                        className="bg-rose-500 hover:bg-rose-600 px-6 p-1 text-xl text-gray-950 rounded-md">
                        واتساب
                      </a>
                    </button>{" "}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section class="bg-gray-100" id="aboutus">
          <div class="container mx-auto py-16 px-4 sm:px-6 lg:px-8">
            <div class="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
              <div class="max-w-lg">
                <h2
                  style={{ lineHeight: "1.4" }}
                  class="text-3xl font-bold text-gray-800 mb-8 text-center">
                  شركة مرعي للمقاولات العامة والتوريدات
                </h2>
                <p class="mt-4 text-gray-600 text-lg">
                  تتمتع شركة مرعي بخبرة واسعة في تطوير البنية التحتية، بما في
                  ذلك بناء الطرق والجسور وشبكات المياه والصرف الصحي والكهرباء.
                  تلتزم الشركة بأعلى معايير الجودة والسلامة في جميع مشاريعها،
                  مما يضمن تقديم حلول مستدامة وفعّالة تلبي احتياجات العملاء
                  والمجتمع.
                </p>
                <br />
                <p class="mt-4 text-gray-600 text-lg">
                  بفضل التزامها بالتميز والجودة، تمكنت شركة مرعي للمقاولات
                  العامة من بناء سمعة قوية كشركة موثوقة ومهنية في قطاع البنية
                  التحتية. وتواصل الشركة مسيرتها في تقديم أفضل الخدمات والمساهمة
                  في تطوير البنية التحتية لتحقيق مستقبل أفضل.
                </p>
              </div>
              <div class="mt-12 md:mt-0">
                <img
                  src={img8}
                  alt="About Us Image"
                  class="object-cover rounded-lg shadow-md"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="text-gray-700 mr-5 body-font select-none" id="gallery">
          <div className="flex justify-center text-3xl font-bold text-gray-800 text-center py-10">
            اعمالنا لا تنتهي{" "}
            <MdOutlineWorkspacePremium className="text-4xl text-rose-600" />
          </div>

          <div className="p-4">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={10}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              breakpoints={{
                640: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
              }}
              className="mySwiper">
              {gallery.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="group relative">
                    <img
                      loading="lazy"
                      src={item.image}
                      alt="Image"
                      className="aspect-[2/3] h-80 object-cover rounded-lg transition-transform transform scale-100"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      </section>
    </>
  );
};

export default Infrastructure;
